import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

function AppRedirect() {
  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const currentPath = window.location.pathname;
    
    const androidPackage = "com.sdf.untitled";
    const iosAppId = "6446928977";
    const schemeUrl = `com.sdf.untitled://${currentPath}`;

    if (/android/i.test(userAgent)) {
      window.location = "intent://" + currentPath + "#Intent;scheme=com.sdf.untitled;package=" 
                        + androidPackage 
                        + ";S.browser_fallback_url=https://play.google.com/store/apps/details?id=" 
                        + androidPackage 
                        + ";end";
    } 
    else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      const now = new Date().getTime();
      window.location = schemeUrl;
      setTimeout(() => {
        if (new Date().getTime() - now < 2000) {
          window.location = "https://apps.apple.com/app/id" + iosAppId;
        }
      }, 1500);
    }
    else if (/Mac/.test(userAgent)) {
      window.location = "https://apps.apple.com/app/id" + iosAppId;
    }
    else if (/Win/.test(userAgent)) {
      window.location = "https://play.google.com/store/apps/details?id=" + androidPackage;
    }
    else {
      window.location = "https://play.google.com/store/apps/details?id=" + androidPackage;
    }
  }, []);

  return (
    <div style={{ textAlign: 'center', padding: '50px' }}>
      <h1>Opening SoulLab...</h1>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="*" element={<AppRedirect />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
